(function () {
  function num(t) {
    if (!t) return NaN;
    var m = t.replace(/\s/g, '').match(/\d[\d.,]*/);
    if (!m) return NaN;
    var s = m[0];
    if (/,\d{2}$/.test(s) && s.indexOf('.') > -1) s = s.replace(/\./g, '').replace(',', '.');
    else if (/,\d{2}$/.test(s)) s = s.replace(',', '.');
    else s = s.replace(/,/g, '');
    return parseFloat(s);
  }
  function cur(t) { var m = (t || '').trim().match(/^[^\d]*/); return m ? m[0].trim() : ''; }
  function prices(scope) {
    var p = scope.querySelector('.price--on-sale');
    if (!p) return null;
    var reg = p.querySelector('s.price-item--regular, .price__sale .price-item--regular');
    var sale = p.querySelector('.price-item--sale.price-item--last') || p.querySelector('.price-item--sale');
    if (!reg || !sale) return null;
    var r = num(reg.textContent), s = num(sale.textContent);
    if (!(r > s && s > 0)) return null;
    return { r: r, s: s, c: cur(sale.textContent), pct: Math.round((1 - s / r) * 100) };
  }
  function cards() {
    document.querySelectorAll('.card-wrapper').forEach(function (c) {
      var d = prices(c);
      var b = c.querySelector('.card__badge .badge');
      if (!b || !d || d.pct < 5) return;
      if (/sale/i.test(b.textContent) || /^-\d+%$/.test(b.textContent.trim())) {
        var t = '-' + d.pct + '%';
        if (b.textContent.trim() !== t) b.textContent = t;
      }
    });
  }
  function pdp() {
    var info = document.querySelector('product-info');
    if (!info) return;
    var title = info.querySelector('.product__title');
    if (title && !info.querySelector('.mh-pdp-eyebrow')) {
      var e = document.createElement('span');
      e.className = 'mh-pdp-eyebrow';
      /* Resell products (reseller strip present on the page) get their own label */
      e.textContent = document.querySelector('.mhr') ? "Melanie's Resell Collection" : "Melanie's Edit";
      title.parentNode.insertBefore(e, title);
    }
    var save = info.querySelector('.mh-save');
    function update() {
      var d = prices(info);
      var priceBox = info.querySelector('.price');
      if (d && priceBox) {
        var diff = (d.r - d.s).toFixed(2);
        var txt = 'You save ' + d.c + diff + ' (' + d.pct + '% off)';
        if (!save) {
          save = document.createElement('p');
          save.className = 'mh-save';
          var host = priceBox.closest('.product__price') || priceBox.parentNode;
          host.parentNode.insertBefore(save, host.nextSibling);
        }
        if (save.textContent !== txt) save.textContent = txt;
      } else if (save) {
        save.remove(); save = null;
      }
      var sp = document.querySelector('.mh-sticky__price');
      var cp = info.querySelector('.price-item--last') || info.querySelector('.price-item');
      if (sp && cp && sp.textContent !== cp.textContent.trim()) sp.textContent = cp.textContent.trim();
    }
    var submit = info.querySelector('.product-form__submit');
    if (submit && !document.querySelector('.mh-sticky')) {
      var bar = document.createElement('div');
      bar.className = 'mh-sticky';
      bar.innerHTML = '<div class="mh-sticky__info"><div class="mh-sticky__title"></div><div class="mh-sticky__price"></div></div><button type="button" class="mh-sticky__btn"></button>';
      document.body.appendChild(bar);
      var ttl = info.querySelector('.product__title');
      bar.querySelector('.mh-sticky__title').textContent = ttl ? ttl.textContent.trim() : '';
      var btn = bar.querySelector('.mh-sticky__btn');
      btn.addEventListener('click', function () {
        var s = info.querySelector('.product-form__submit');
        if (s && !s.disabled) s.click();
      });
      var vis = true;
      function sync() {
        var s = info.querySelector('.product-form__submit');
        if (!s) return;
        btn.disabled = s.disabled;
        var lbl = s.querySelector('span');
        btn.textContent = (lbl ? lbl.textContent : s.textContent).trim() || 'Add to cart';
        bar.classList.toggle('is-on', !vis);
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { vis = en[0].isIntersecting; sync(); }).observe(submit);
      }
      new MutationObserver(function () { sync(); }).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      sync();
    }
    update();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(update, 60); }).observe(info, { childList: true, subtree: true, characterData: true });
  }
  function boot() {
    cards(); pdp();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(cards, 80); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();